import { BY_DEFAULT, COMPLIMENTARY_MODIFIER, CORE_MODIFIERS, CORE_RELATED, SINGLE_ITEM_SELECTED_SECTION } from "../../constants";
import { Codes } from "../../models/item.model";
import { ISelectedModifier } from "../../models/try2Combo";
import { itemBuckets } from "../../priceCalculation/buckets";
import { ICurrentModifier } from "../../priceCalculation/priceCalculation";
import { nullValueVerify } from "../helperMethods";
import _clonedeep from 'lodash.clonedeep'


const indexOfyDefaultComplementary = (modifier) => {
  if(modifier?.complimentary_modifier){
    const complementaryBucket = itemBuckets?.getSingleBucket({name:COMPLIMENTARY_MODIFIER, fromItem: SINGLE_ITEM_SELECTED_SECTION, isFromItemComingAsAnIndex:true});
    const findIndex = complementaryBucket?.byDefaultAddedV2?.modifiers?.findIndex(mod => mod?.modifier_id === modifier?.modifier_id)
    return findIndex >= 0
  }else{
    return false
  }
}

const isItByDefaultSelected = (modifier,selectedModifiers) => {
  const index = selectedModifiers.findIndex(mod => mod?.id === modifier?.modifier_id);
  if(index !== -1 ){
    return true;
  }
  return false
}

const addCalories = (modifier, selectedModifiers) => {
  if(modifier?.complimentary_modifier){
    const index = indexOfyDefaultComplementary(modifier);
    if((modifier?.type === BY_DEFAULT || index) && modifier.quantity <= 1){
      return false
    }
      if (index && modifier?.quantity <= 1) {
        return true;
      }
  }
  if(!modifier.quantity){
    modifier.quantity = 1
  }
  if((modifier?.core || modifier?.type === BY_DEFAULT) && modifier.quantity === 1){
    return false
  }
  if(isItByDefaultSelected(modifier, selectedModifiers) && modifier.quantity === 1){
    return false
  }
  return true
}

const modifierQuantity = (modifier, selectedModifiers) => {
  if(modifier?.complimentary_modifier){
    const index = indexOfyDefaultComplementary(modifier);
      if (index) {
        return modifier.quantity - 1
      }
  }
  if((modifier?.core || modifier?.type === BY_DEFAULT) && modifier.quantity > 1){
    return modifier.quantity - 1
  }else if(isItByDefaultSelected(modifier, selectedModifiers) && modifier.quantity > 1){
    return modifier.quantity - 1
  }else{
    return modifier.quantity
  }
}

const isItSubstituteGroup = (modifier:ICurrentModifier) => {
  return modifier?.modifier_group_min === 1 && modifier?.modifier_group_max === 1 && modifier?.extendableLimitValue === 1
}

const calculateSubstituteGroupCalories = (totalCalories:number,selectedModifiers, modifier:ISelectedModifier) => {
  const currentModifier = selectedModifiers?.find(
    (mod) => mod?.modifier_group_id === modifier?.modifier_group_id
  );
  if(currentModifier){
    const calories = modifier.modifier_calories - currentModifier?.calories;
    if (calories > 0) {
      return totalCalories + calories;
    }else{
      return totalCalories
    }
  }else{
    return totalCalories + modifier?.modifier_calories
  }
};

const getModifierCombineCalories = (customizedItem, selectedModifiers) => {
  let totalCalories = 0;
  for (let item of customizedItem) {
    for (let i = 0; i < item?.modifiers.length; i++) {
      const modifier = item?.modifiers[i];
            if (modifier.code !== Codes.NO) {
        if (addCalories(_clonedeep(modifier), selectedModifiers)) {
          if(isItSubstituteGroup(modifier)){
            totalCalories = calculateSubstituteGroupCalories(totalCalories,selectedModifiers,modifier)
          }else{
            totalCalories += +modifier.modifier_calories * (modifierQuantity({...modifier}, selectedModifiers) || 1);
          }
          }
        }
    }
  }
  return totalCalories;
};

// Item calories can be null if need info based on which is in item customization context
export const getCustomizedItemCalories = (customizedItem, itemCalories, selectedModifiers) => {
  let totalCalories = 0;
  if (customizedItem.item_id) {
    totalCalories += itemCalories
      ? +itemCalories
      : +customizedItem.item_calories;
    if (!nullValueVerify(customizedItem.modifiers)) {
      totalCalories += +getModifierCombineCalories(customizedItem.modifiers, selectedModifiers);
    }
  }
  return parseFloat(parseFloat(String(totalCalories)).toFixed(2));
};
